class ReportListController {

    constructor(messageService, reportsService, access) {
        this.reports = reportsService;
        this.messageService = messageService;
        this.access = access;
    }

    generateReport () {
        this.generating = true;

        if (this.reportFields()) {
            this.reports.generate({
                'type': this.type,
                'status': this.status,
                'payment': this.payment,
                'datefrom': (this.datefrom ? this.datefrom.format('YYYY-MM-DD') : undefined),
                'dateto': (this.dateto ? this.dateto.format('YYYY-MM-DD') : undefined),
                'date': (this.date ? this.date.format('YYYY-MM') : undefined),
                'bookedfor': (this.bookedfor ? this.bookedfor.format('YYYY-MM-DD') : undefined),
                'event': this.event,
                'offer': this.offer,
                'voucher': this.voucher,
                'promo': this.promo,
            }).then(response => {
                this.download = response.link;
                this.filename = response.name;
                this.generating = false;
            }).catch(response => {
                this.messageService.failure('Unfortunately that report could not be generated, please try again.');
                this.messageService.push();
                this.messageService.autoClear();
                this.generating = false;
            });
        } else {
            this.generating = false;
        }
    }

    reportFields () {
        switch (this.type) {
            case 'order':
            case 'item':
                if (!this.datefrom) {
                    this.messageService.failure("Please select an 'Orders created, starting from' date to report on.");
                    this.messageService.push();
                    this.messageService.autoClear();
                    return false;
                } else {
                    return true;
                }

            case 'guest':
                if (!this.bookedfor) {
                    this.messageService.failure("Please select a 'Booked for' date to report on.");
                    this.messageService.push();
                    this.messageService.autoClear();
                    return false;
                } else {
                    return true;
                }

            case 'marketing':
                return true;

            case 'finance':
                if (!this.date) {
                    this.messageService.failure("Please select a date to report on.");
                    this.messageService.push();
                    this.messageService.autoClear();
                    return false;
                } else {
                    return true;
                }

            default:
                this.messageService.failure('Please select a report type.');
                this.messageService.push();
                this.messageService.autoClear();
                return false;
        }
    }

    invalidType (field) {
        let validityRules = {
            'status': ['order', 'item', 'guest'],
            'payment': ['order', 'item', 'guest'],
            'datefrom': ['order', 'item'],
            'date': ['finance'],
            'dateto': ['order', 'item'],
            'bookedfor': ['guest'],
            'event': ['order', 'item'],
            'offer': ['item'],
            'voucher': ['order'],
            'promo': ['order'],
        };
        return validityRules[field].indexOf(this.type) === -1;
    }

    clearForm () {
        if (this.invalidType('status')) this.status = '';
        if (this.invalidType('payment')) this.payment = '';
        if (this.invalidType('datefrom')) this.datefrom = '';
        if (this.invalidType('dateto')) this.dateto = '';
        if (this.invalidType('date')) this.date = '';
        if (this.invalidType('bookedfor')) this.bookedfor = '';
        if (this.invalidType('event')) this.event = '';
        if (this.invalidType('offer')) this.offer = '';
        if (this.invalidType('voucher')) this.voucher = '';
        if (this.invalidType('promo')) this.promo = '';
    }

    selectType (type) {
        this.type = type;
        this.clearForm();
    }
}

ReportListController.$inject = ['messageService', 'reportsService', 'access'];

export default ReportListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/reports/controllers/reports.list.controller.js